import { customThemes } from "@softura/fluentui-themes";
import React, { createContext, lazy, Suspense, useContext, useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import "./App.scss";
import "@progress/kendo-theme-default/dist/all.css";
import i18n from "i18next";
import { UserProfile } from "../../interfaces/userprofile";
import userServices from "../../services/userservices";
import Loader from "../Loader";
import { operations as headeroperations } from "../../state/features/header";
import { IsEmpty } from "../../utils/string";
import { initReactI18next } from "react-i18next";
import backend from "i18next-http-backend";
import translationservice from "../../services/translationservice";
import DistributorService from "../../services/distributorservice";
import { operations as commondataoperations } from "../../state/features/common/globaldata";
import SessionError from "../CommonComponent/SessionError";
import { useLocation } from "react-router-dom";
import LandingUE from "../LandingUE";
import UnAuthorized from "../UnAuthorized";
import { REGION } from "../../const/linksection";
import { getAppInsights } from '../../appInsights';
import TelemetryProvider from '../CommonComponent/AppInsights/telemetryprovider';
import GuestUserShoppingCart from "../GuestUserShoppingCart";
import partsservice from "../../services/partsservice";
import helperFunctions from "../../utils/helperfunctions";
import UserRegistration from "../UserRegistration";
import { selectors as globalDataSelector } from "../../state/features/common/globaldata";
import { IAppContextProps } from "./AppInterface";
import { selectors as headerSelector } from "../../state/features/header";

const Header = lazy(() => import("../Header"));
const Navigation = lazy(() => import("../Navigation"));
const Footer = lazy(() => import("../Footer"));
const ErrorBoundary = lazy(() => import("../Error"));
const RoutesPages = lazy(() => import("../Routes"));

const AppContext = createContext<IAppContextProps | undefined>(undefined);

customThemes("MyKomatsu");
function App() {
    const dispatch = useDispatch();
    const dispatchsetCurrentUser = headeroperations.dispatchsetCurrentUser(dispatch);
    const dispatchsetbaseUrl = headeroperations.dispatchsetbaseUrl(dispatch);
    const dispatchMyKomatsuBaseUrl = headeroperations.dispatchMyKomatsuBaseUrl(dispatch);
    const dispatchMyKomatsuRegion = headeroperations.dispatchMyKomatsuRegion(dispatch);
    const dispatchIsMinExpoEnabled = headeroperations.dispatchIsMinExpoEnabled(dispatch);
    const dispatchKomatsuCareBrochures = headeroperations.dispatchKomatsuCareBrochures(dispatch);
    const dispatchsetGlobalData =
        commondataoperations.dispatchCurrentGlobalData(dispatch);
    const [isAuthenticated, setIsAuthenticated] = useState<any | null>(null);
    const [userId, setUserId] = useState();
    const [currentUser = {} as UserProfile, setUserProfileInfo] = useState({} as UserProfile);
    const [imgUrl, setImgUrl] = useState();
    const [isAuthorizedUser, setAuthorizedUserState] = useState(true);
    const isSignedOnce = sessionStorage.getItem("isSigned") ?? "false";
    const [myKomatsuBaseUrl, setMyKomatsuBaseUrl] = useState<any>("");
    const [myKomatsuRegion, setMyKomatsuRegion] = useState<any>("");
    const [komatsuCareBrochures, setKomatsuCareBrochures] = useState<any>("");
    const [userType, setUserType] = useState<any>("");
    const [sessionTimeOut, setSessionTimeOut] = useState<number>();
    const [email, setemail] = useState('')
    const location = useLocation();
    const windowHcalc = window.innerHeight - 260;
    const dispatchMapCenter = headeroperations.dispatchMapCenter(dispatch);
    const [appInsightsKey, setAppInsightsKey] = useState<string>();
    const [isAppInsightsEnabled, setIsAppInsightsEnabled] = useState<boolean>(false);
    let appInsights: any = null;
    const [guestUser, setGuestUser] = useState(false);
    const [isMiningDistributor, setIsMiningDistributor] = useState<any>(null);
    const [psnEnableSerialMapping, setPsnEnableSerialMapping] = useState<any>(false);
    const [isWacMixedFleetDistributor, setIsWacMixedFleetDistributor] = useState<any>(null);
    const [isMixedFleetDistributor, setIsMixedFleetDistributor] = useState<any>(null);
    const [isLoading, setIsLoading] = useState(false);

    const dispatchDistributorData = commondataoperations.dispatchDistributorData(dispatch);

    const { headercurrentuser }: any = useSelector((state) => ({
        headercurrentuser: headerSelector.currentuser(state),
    }));

    useEffect(()=>{
        const userId = headercurrentuser?.azureADId || "";
        if (userId) {
            getDistributorList(userId);
        }
    },[headercurrentuser])

    const getDistributorList = (userId: any) => {
        setIsLoading(true);
        DistributorService.getDistributors(userId)
            .then(async (response: any) => {
                dispatchDistributorData(await response);
                setIsLoading(false);
            })
            .catch((e: any) => {
                setIsLoading(false);
            });
    }

    useEffect(() => {
        const handleTabClose = (event: any) => {
            event.preventDefault();
            helperFunctions.ClearLocalStorage();
            helperFunctions.saveSelectedDateSessionData(userId, "", "");
            window.addEventListener('beforeunload', handleTabClose);
            return () => {
                window.removeEventListener('beforeunload', handleTabClose);
            };
        }
    }, []);

    useEffect(() => {
        if (location?.pathname != "/login" && location?.pathname != "/CustomerRegister") {
            fetchData();
            GetAppInsightsKey();
            GetIsMinExpoEnabledKey();
        }
    }, []);

    useEffect(() => {
        if (location?.pathname != "/login" && location?.pathname != "/CustomerRegister") {
            dispatchsetCurrentUser(currentUser);
            dispatchsetbaseUrl(imgUrl);
        }
    }, [currentUser, imgUrl]);

    useEffect(() => {
        if (location?.pathname != "/login") {
            dispatchMyKomatsuBaseUrl(myKomatsuBaseUrl);
        }
    }, [myKomatsuBaseUrl])

    useEffect(() => {
        dispatchMyKomatsuRegion(myKomatsuRegion);
    }, [myKomatsuRegion])

    useEffect(() => {
        if (myKomatsuRegion == REGION.Europe)
            dispatchKomatsuCareBrochures(komatsuCareBrochures);
    }, [komatsuCareBrochures])

    const { globalData, distributorData }: any = useSelector((state) => ({
        globalData: globalDataSelector.globaldata(state),
        distributorData: globalDataSelector.distributordata(state),
    }));

    useEffect(() => {
        let distributorArray = Object.values(distributorData).filter(
            (value) => typeof value === "object"
        );
        if (distributorArray?.length) {
            if(globalData?.DistributorCode)  {
                const distributor: any = distributorArray.find((item: any) => item?.id === globalData?.DistributorCode);
                setIsMiningDistributor(distributor?.distributorTypeCode?.toLowerCase() === 'smining');
                setIsMixedFleetDistributor(distributor?.distributorTypeCode?.toLowerCase() === 'msmining');

            } else {
                setIsMiningDistributor(false);
                setIsMixedFleetDistributor(false);
            }
            if (headercurrentuser?.isWideAreaUser) {
                const isMininrDist = distributorArray?.filter((s: any) => s?.distributorTypeCode?.toLowerCase() === 'smining');
                const isOtherThenMining = distributorArray?.filter((s: any) => s?.distributorTypeCode?.toLowerCase() !== 'smining');
                setIsWacMixedFleetDistributor(isMininrDist?.length > 0 && isOtherThenMining?.length > 0);
            }
            else {
                setIsWacMixedFleetDistributor(false);
            }
        } else {
            if (isWacMixedFleetDistributor) {
                setIsWacMixedFleetDistributor(false);
            }
            if (isMiningDistributor) {
                setIsMiningDistributor(false);
            }
            if (isMixedFleetDistributor) {
                setIsMixedFleetDistributor(false);
            }
        }
    }, [distributorData, globalData]);

    const fetchData = async () => {
        await fetch("/auth/getUser" + location.search)
            .then(async (response) => await response.json())
            .then((json) => {
                setMyKomatsuBaseUrl(json.myKomatsuBaseUrl);
                setMyKomatsuRegion(json.myKomatsuRegion);

                if (json.myKomatsuRegion == REGION.Europe)
                    setKomatsuCareBrochures(json.komatsuCareBrochures);

                setIsAuthenticated(json.isAuthenticated);
                setUserId(json.currentUserId);
                if (!json.isGuestUser) {
                    setGlobalData(json.currentUserId, json.myKomatsuBaseUrl);
                }
                getTranslationData(json.currentUserId);
                setSessionTimeOut(json.sessionTimeOut);
                setemail(json.userEmail);
                if (json.isAuthenticated)
                {
                    if (json.isGuestUser) {
                        let userInfo = {
                            azureADId: json.currentUserId,
                            isGuestUser : true,
                        }
                        setUserProfileInfo(userInfo as UserProfile);
                        sessionStorage.setItem("isSigned", "true");
                        setAuthorizedUserState(true);
                        setGuestUser(true);
                        retrieveGuestUserProfile(json.currentUserId);
                    }
                    else {
                        retrievelUserProfile(json.currentUserId, json.myKomatsuBaseUrl, json.myKomatsuRegion);
                      
                    }
                    setImgUrl(json.cdnBaseUrl);
                }
                dispatchMapCenter(json?.gmapCenter);
            })
            .catch((error) => {
                setIsAuthenticated(false);
            });
    };

    const getTranslationData = (userid: string) => {
        const backendOptions = {
            loadPath: "{{lng}}",
            request: async (options: any, lng: any, payload: any, callback: any) => {
                try {
                    const response = await translationservice.getTransalationByUserId(
                        userid
                    );
                    callback(null, {
                        data: response,
                        status: 200,
                    });
                } catch (e) {
                    callback(null, {
                        status: 500,
                    });
                }
            },
        };

        i18n
            .use(initReactI18next)
            .use(backend)
            .init({
                fallbackLng: "en-us",
                lng: "en-us",
                load: 'currentOnly',
                backend: backendOptions,
                interpolation: {
                    escapeValue: false,
                },
                lowerCaseLng: true
            });
    };

    const retrieveGuestUserProfile = (anonymousId: string) => {
        partsservice.getGuestUserProfile(anonymousId)
            .then((response: any) => {
                let userInfo: any = {
                    id: response?.id,
                    fn: response?.firstName,
                    ln: response?.lastName,
                    eml: response?.email,
                    dbid: response?.distributor4Code,
                    isGuestUser: true,
                    guestBranchCode: response?.distributorBranch2Code,
                    guestDistributorCode: response?.distributor4Code,
                    azureADId: response?.anonymousId,
                    guestZipCode: response?.zip
                };

                setUserProfileInfo(userInfo as UserProfile);
                dispatchsetGlobalData({ DistributorCode: response?.distributor4Code, DistributorName: response?.distributorName, CustomerId: 0, CustomerName: "", LocationId: 0, LocationName: "", BranchCode: response?.distributorBranch2Code, BranchName: "" });
                if (IsEmpty(userInfo?.anonymousId)) {
                    setAuthorizedUserState(false);
                    sessionStorage.setItem("isSigned", "false");
                } else {
                    sessionStorage.setItem("isSigned", "true");
                    setAuthorizedUserState(true);
                }
            })
            .catch((e) => {
                setAuthorizedUserState(false);
                sessionStorage.setItem("isSigned", "false");
            });
    };

    const retrievelUserProfile = async (uId: string, url: string, region: string) => {
        if (isSignedOnce == "false") {
            await userServices
                .getmyProfile(uId, region)
                .then((response) => {
                    let userInfo = response as UserProfile;
                    let usertype = userInfo.usertype.name?.toLocaleLowerCase();
                    setUserType(usertype);
                    if (usertype == "bookonly") {
                        window.location.href = url + "/Documents/Index";
                    } else {
                        setUserProfileInfo(userInfo);
                        if (IsEmpty(userInfo.eml) || !userInfo.isActive) {
                            setAuthorizedUserState(false);
                            sessionStorage.setItem("isSigned", "false");
                        } else {
                            sessionStorage.setItem("isSigned", "true");
                            setAuthorizedUserState(true);
                        }
                    }
                })
                .catch((e) => {
                    setAuthorizedUserState(false);
                    sessionStorage.setItem("isSigned", "false");
                });
        } else {
            await userServices
                .getUserProfile(uId, region)
                .then((response) => {
                    let userInfo = response as UserProfile;
                    setUserProfileInfo(userInfo);
                    if (IsEmpty(userInfo.azureADId) || !userInfo.isActive) {
                        setAuthorizedUserState(false);
                    }
                    else {
                        setAuthorizedUserState(true);
                    }
                })
                .catch((e) => {
                    setAuthorizedUserState(false);
                });
        }
    };

    const setGlobalData = (userId: string, baseURL: string) => {
    DistributorService.getSessionData(userId)
        .then(async (response: any) => {
            if ((!response?.LoggedInFrom || response?.LoggedInFrom != 'MykMvcApp') && window.location?.hostname?.toLowerCase() != 'localhost') {
               window.location.href = baseURL + "/Fleet/index";
            }
            dispatchsetGlobalData({ DistributorCode: response?.DistributorCode, DistributorName: response?.DistributorName, CustomerId: response?.CustomerId, CustomerName: response?.CustomerName, LocationId: response?.LocationId, LocationName: response?.LocationName, BranchCode: response?.BranchCode, BranchName: response?.BranchName, LoggedInFrom: response?.LoggedInFrom, ...response });
      })
      .catch((e: any) => { });
  }

    const login = () => {
        const returnUrl = `${window.location.pathname}${window.location.search}`;
        window.location.href = `/auth/index?returnUrl=${returnUrl}`;
        return null;
    };

    const GetAppInsightsKey = () => {
        fetch("/auth/GetAppInsightsKey")
            .then(async (response) => await response.json())
            .then((json) => {
                setAppInsightsKey(json.insightsKey);
                setIsAppInsightsEnabled(json.isAppInsightsEnabled);
            })
            .catch(() => {
                setAppInsightsKey('');
                setIsAppInsightsEnabled(false);
            });
    }

    const GetIsMinExpoEnabledKey = () => {
        fetch("/auth/GetIsMinExpoEnabledKey")
            .then(async (response) => await response.json())
            .then((json) => {
                dispatchIsMinExpoEnabled(json?.isMinExpoEnabled);
            })
            .catch(() => {
                dispatchIsMinExpoEnabled(false);
            });
    }

    const contextValue = useMemo<IAppContextProps>(() =>
        (
            {
            isMiningDistributor,
            isMixedFleetDistributor,
            setIsMixedFleetDistributor,
            isWacMixedFleetDistributor,
            psnEnableSerialMapping
        }
    ), [isMiningDistributor, isMixedFleetDistributor, isWacMixedFleetDistributor, psnEnableSerialMapping]);

    useEffect(() => {
        getPsnEnableSerialMapping();
    }, []);

    const getPsnEnableSerialMapping = () => {
        fetch("/auth/GetPsnEnableSerialMapping")
            .then((response) => response.json())
            .then((data: any) => {
                setPsnEnableSerialMapping(data?.psnEnableSerialMapping ?? false);
            })
            .catch((error) => {
                setPsnEnableSerialMapping(false);
            });
    };

    if (location?.pathname == "/login") {
        return (<LandingUE />)
    } else if (location?.pathname == "/CustomerRegister") {
        return (<UserRegistration />)
    }
    else if (isAuthenticated && userType != "bookonly") {
        return (
            <div className="top_Section">
                {isLoading && <Loader />}
                <Suspense fallback={<Loader />}>
                    <AppContext.Provider value={contextValue}>
                        <ErrorBoundary imgURL={imgUrl} userEmail={email} userId={userId}>
                        <TelemetryProvider instrumentationKey={appInsightsKey} isAppInsightsEnabled={isAppInsightsEnabled} key={userId} after={() => { appInsights = getAppInsights(); appInsights.setAuthenticatedUserContext(email) }}>
                            {guestUser ?
                                <GuestUserShoppingCart /> :
                                <>
                                    <Header userId={userId} isAuthorizedUser={isAuthorizedUser} isMiningDistributor= {isMiningDistributor} />
                                    <Navigation userId={userId} isMiningDistributor= {isMiningDistributor} />
                                    <div className='wrapperHDH' style={{ "minHeight": windowHcalc + "px" }}>
                                        <RoutesPages isAuthorizedUser={isAuthorizedUser} />
                                    </div>
                                    <Footer userId={userId} isMiningDistributor= {isMiningDistributor} />
                                </>
                            }
                        </TelemetryProvider>
                    </ErrorBoundary>
                    <SessionError sessionTimeOut={sessionTimeOut} />
                    </AppContext.Provider>
                </Suspense>
            </div>
        );
    }
    else if (isAuthenticated != null && isAuthenticated == false && location.pathname != '/Account/AccessDenied') {
        return login();
    } else if (location.pathname == '/Account/AccessDenied') {
        return (
            <UnAuthorized />
        )
    } else {
        return null;
    }
}


export default App;

export const useAppContext = (): IAppContextProps => {
    return useContext(AppContext) as IAppContextProps;
};
